var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "#29C5F6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.49896 6H8.09896C7.09896 6 6.59896 7.1 7.29896 7.8L12.999 13.5C14.599 15.1 17.299 15.1 18.899 13.5L24.599 7.8C25.399 7.1 24.899 6 23.899 6H22.499C21.699 6 20.899 6.3 20.299 6.9L16.699 10.5C16.299 10.9 15.599 10.9 15.199 10.5L11.699 6.9C11.099 6.3 10.299 6 9.49896 6Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.50004 25.9998H8.10004C7.20004 25.9998 6.70004 24.8998 7.40004 24.1998L13 18.4998C14.6 16.8998 17.3 16.8998 18.9 18.4998L24.6 24.1998C25.3 24.8998 24.8 25.9998 23.9 25.9998H22.5C21.7 25.9998 20.9 25.6998 20.3 25.0998L16.7 21.4998C16.3 21.0998 15.6 21.0998 15.2 21.4998L11.6 25.0998C11.1 25.5998 10.3 25.9998 9.50004 25.9998Z",
    stroke: "#F1F1F1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXTwitter);
export default __webpack_public_path__ + "static/media/X-Twitter.f259ec40d13e64110734cc9a4de58cb6.svg";
export { ForwardRef as ReactComponent };